export default __webpack_public_path__ + "static/media/rating-star-icon.120ebd34.svg";